import { render, staticRenderFns } from "./Issuequery.vue?vue&type=template&id=df4e1e2e&scoped=true&"
import script from "./Issuequery.vue?vue&type=script&lang=js&"
export * from "./Issuequery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e1e2e",
  null
  
)

export default component.exports